import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { CreateParticipant as C } from '../../features/users'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function EditParticipant(props: RouteProps) {
  const { setTitle } = useTitleHeaderContext()
  setTitle(props.title || '')

  return <C id={props.id} />
}
